import React, { MouseEventHandler, useCallback, useId } from 'react';
import { CheckboxProps } from './interfaces';
import { useElement } from '../../react';
import classNames from 'classnames';
import './Checkbox.scss';

export interface ExtendedCheckboxProps extends CheckboxProps {
    type?: 'checkmark' | 'square';
    value?: boolean;
}

export const Checkbox: React.FC<ExtendedCheckboxProps> = (props) => {
    const { name, label, checked, onChange, className, disabled = false, type = 'checkmark', value } = props;

    const { target } = useElement<HTMLInputElement>();

    const wrapperClick = useCallback<MouseEventHandler>(() => {
        if (!disabled) target?.current?.click();
    }, [target, disabled]);

    const id = useId();

    const checkboxClick = useCallback<MouseEventHandler>((event) => {
        event.stopPropagation();
    }, []);

    const checkboxChange = useCallback<React.ChangeEventHandler<HTMLInputElement>>(
        (event) => {
            event.stopPropagation();
            if (!disabled) onChange?.(event);
        },
        [onChange, disabled],
    );

    return (
        <div
            className={classNames(
                'ui-checkbox',
                'non-selectable',
                { active: checked || !!value },
                { disabled },
                className,
            )}
            onClick={wrapperClick}
        >
            <aside className='ui-checkbox__overlay' />
            <input
                id={id}
                ref={target}
                name={name}
                type='checkbox'
                onChange={checkboxChange}
                onClick={checkboxClick}
                checked={checked || !!value}
                className={classNames('ui-checkbox__input', {
                    active: checked || !!value,
                    checkmark: type === 'checkmark',
                    square: type === 'square',
                })}
            />
            <label
                className='ui-checkbox__label'
                htmlFor={id}
                onClick={checkboxClick}
            >
                {label}
            </label>
        </div>
    );
};
